import { getBatchOperation } from '@lib/api'
import { BatchOperationStatus } from 'types'

export const pollBatchOperation = async (
  batchOperation: BatchOperation,
  pollingInterval = 2000, // Default polling interval in milliseconds
): Promise<BatchOperation> => {
  return new Promise((resolve, reject) => {
    const poll = async () => {
      try {
        batchOperation = await getBatchOperation(batchOperation.id)

        if (batchOperation.status === BatchOperationStatus.Completed) {
          resolve(batchOperation)
        } else if (batchOperation.status === BatchOperationStatus.Failed) {
          reject(new Error('Batch operation failed'))
        } else {
          // Continue polling
          setTimeout(() => void poll(), pollingInterval)
        }
      } catch (error) {
        reject(error)
      }
    }

    poll().catch((error) => {
      // Handle any unexpected errors during polling
      reject(error)
    })
  })
}
